// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"112":"build-glob","220":"build-doc","839":"build-map"}[chunkId] + "." + {"112":"c1d4969f","220":"6561e602","839":"2a18ff7e"}[chunkId] + ".css";
};